<form class="filter" #formElement [formGroup]="form">
  <mat-form-field class="medium-width">
      <input matInput autocomplete="off" formControlName="DateFrom" [matDatepicker]="pickerFrom" placeholder="Fecha" required>
      <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
      <mat-datepicker #pickerFrom></mat-datepicker>
      <mat-error *ngIf="f.DateFrom.errors && f.DateFrom.errors.required">
          Ingrese la fecha
      </mat-error>
  </mat-form-field>

  <mat-form-field class="medium-width">
    <input matInput autocomplete="off" formControlName="DateTo" [matDatepicker]="pickerTo" placeholder="Fecha" required>
    <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
    <mat-datepicker #pickerTo></mat-datepicker>
    <mat-error *ngIf="f.DateTo.errors && f.DateTo.errors.required">
        Ingrese la fecha
    </mat-error>
</mat-form-field>

  <mat-form-field class="full-width">
      <input type="text" #doctor matInput placeholder="Servicio" formControlName="Service" [matAutocomplete]="autService">
      <mat-autocomplete #autService="matAutocomplete" [displayWith]="filterCompleteServices.displayFn">
          <mat-option *ngFor="let service of filteredServicesOptions | async" [value]="service">
              {{service.Name}}
          </mat-option>
      </mat-autocomplete>
  </mat-form-field>

  <mat-form-field  class="full-width">
      <input type="text" #practiceRegion matInput placeholder="Práctica" formControlName="PracticeRegion" [matAutocomplete]="autPracticeRegion">
      <mat-autocomplete #autPracticeRegion="matAutocomplete" [displayWith]="filterCompletePracticesRegion.displayFn">
          <mat-option *ngFor="let practiceRegion of filteredPracticesRegionOptions | async" [value]="practiceRegion">
              {{practiceRegion.Name}}
          </mat-option>
      </mat-autocomplete>
  </mat-form-field>

  <div class="full-width">
      <patient-autocomplete formControlName="Patient"></patient-autocomplete>
  </div>

  <mat-form-field  class="medium-width">
        <input type="text" #pedicalAppointmentWaitState matInput placeholder="Estado" formControlName="MedicalAppointmentWaitState" [matAutocomplete]="autMedicalAppointmentWaitState">
        <mat-autocomplete #autMedicalAppointmentWaitState="matAutocomplete" [displayWith]="filterCompleteMedicalAppointmentWaitState.displayFn">
            <mat-option *ngFor="let medicalAppointmentWaitState of filteredMedicalAppointmentWaitStateOptions | async" [value]="medicalAppointmentWaitState">
                {{medicalAppointmentWaitState.Name}}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>

    <mat-form-field  class="medium-width">
      <input type="text" #center matInput placeholder="Centro" formControlName="Center" [matAutocomplete]="autCenter">
      <mat-autocomplete #autCenter="matAutocomplete" [displayWith]="filterCompleteCenter.displayFn">
          <mat-option *ngFor="let center of filteredCenterOptions | async" [value]="center">
              {{center.Name}}
          </mat-option>
      </mat-autocomplete>
  </mat-form-field>

    <mat-checkbox class="margin-right-small" formControlName="OnlyInterned">Solo internados</mat-checkbox>
</form>
